import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { useDataChange, useDataSubmit, useDataValue } from 'Simple/Data'
import mutation from './mutation.graphql.js'

export default function useDataOnSubmit(props) {
  let id = useDataValue({
    viewPath: props.viewPath,
    context: 'event',
    path: 'appointment.booking._id',
  })
  let refreshEmbeddedSection = useDataChange({
    context: 'global',
    path: 'refresh_embedded_section',
    viewPath: props.viewPath,
  })
  let submit = useDataSubmit({
    context: 'patient',
    viewPath: props.viewPath,
  })

  let [, notify] = useNotifications()
  let setFlowTo = useSetFlowTo(props.viewPath)

  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!value.chair_id || !value.provider_id || !value.assistant_id) {
      return true
    }

    let mutationResponse = await executeMutation({
      id,
      provider_id: value.provider_id,
      assistant_id: value.assistant_id,
      chair_id: value.chair_id,
    })
    if (mutationResponse.error) {
      notify(
        notifyError(
          `There was a problem seating the patient. Please try again.`
        )
      )
      return
    }

    // refresh the core embedded section to update show the updated status of the booking
    refreshEmbeddedSection(Date.now())
    submit({
      type: 'showPatient',
      tab: 'treatment_card',
    })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
